import { PopoverProps, StatefulPopoverProps } from '.';
import { borderRadius, marginSize, paddingSize } from '../../Utilities/utils/Theming';

const PopoverSizes: { [key: string]: string } = {
	large: 'var(--epods--popover-large-size)',
	default: 'var(--epods--popover-default-size)',
	compact: 'var(--epods--popover-compact-size)',
	mini: 'var(--epods--popover-mini-size)',
};

const PopoverPadding: { [key: string]: string } = {
	large: 'var(--epods--popover-large-padding)',
	default: 'var(--epods--popover-default-padding)',
	compact: 'var(--epods--popover-compact-padding)',
	mini: 'var(--epods--popover-mini-padding)',
};

const PopoverFontSize: { [key: string]: string } = {
	large: 'var(--epods--popover-large-font-size)',
	default: 'var(--epods--popover-default-font-size)',
	compact: 'var(--epods--popover-compact-font-size)',
	mini: 'var(--epods--popover-mini-font-size)',
};

const PopoverLineHeight: { [key: string]: string } = {
	large: 'var(--epods--popover-large-line-height)',
	default: 'var(--epods--popover-default-line-height)',
	compact: 'var(--epods--popover-compact-line-height)',
	mini: 'var(--epods--popover-mini-line-height)',
};

export const popoverBaseStyle = (props: StatefulPopoverProps & PopoverProps) => {
	const { size = 'default' } = props;

	const isPresetPopoverSize = ['large', 'default', 'compact', 'mini'].includes(size);
	const width = isPresetPopoverSize ? PopoverSizes[size] : size;

	const isPresetPopoverPaddingSize = ['large', 'default', 'compact', 'mini'].includes(size);
	const paddingValueSize = isPresetPopoverPaddingSize ? PopoverPadding[size] : size;

	const isPresetPopoverFontSize = ['large', 'default', 'compact', 'mini'].includes(size);
	const fontSize = isPresetPopoverFontSize ? PopoverFontSize[size] : size;

	const isPresetPopoverLineHeight = ['large', 'default', 'compact', 'mini'].includes(size);
	const lineHeight = isPresetPopoverLineHeight ? PopoverLineHeight[size] : size;

	return {
		backgroundColor: props.inverted ? "var(--epods--color-bg-third-elevation)" : " var(--epods--color-bg-overlays)",
		color: props.inverted ? "var(--epods--color-text-primary)" : "var(--epods--color-text-inverted)", //$theme.popover.popoverText,
		fontFamily: 'var(--epods--font-base)',
		border: 'none',
		...marginSize('0px', '0px', '0px', '0px'),
		...paddingSize(`${paddingValueSize}`, `${paddingValueSize}`, `${paddingValueSize}`, `${paddingValueSize}`),
		fontSize: fontSize,
		lineHeight: lineHeight,
		...borderRadius('0px'),
		':hover': {
			cursor: 'pointer',
		},
		maxWidth: width,
	};
};

export const popoverArrow = (props: StatefulPopoverProps & PopoverProps) => {
	return {
		backgroundColor: props.inverted ? "var(--epods--color-bg-third-elevation)" : " var(--epods--color-bg-overlays)" //$theme.popover.popoverBackground,
	};
};
